<div class="dialog-main">

  <!-- Header -->
  <div class="dialog-header">
    <div class="header-left">
      <span class="dialog-title">Schedule Upload Preview</span>
      <div *ngIf="!hasConflicts" class="summary-pills">
        <span class="pill pill-add">+{{data.added}} Added</span>
        <span class="pill pill-update">{{data.updated}} Updated</span>
        <span class="pill pill-remove">−{{data.removed}} Removed</span>
      </div>
    </div>
    <div *ngIf="hasConflicts" class="conflict-badge">
      <span class="conflict-icon">⚠</span> API Conflict
    </div>
  </div>

  <!-- Conflict banner -->
  <div *ngIf="hasConflicts || editMode" class="conflict-banner">
    <div class="conflict-banner-top">
      <div class="conflict-banner-text">
        <strong>Upload blocked</strong> — the following API(s) are already registered under a different operator.
        Fix the API numbers below or remove these wells from your file.
      </div>
      <button class="btn btn-edit-toggle" (click)="toggleEditMode()">
        {{ editMode ? '✓ Done Editing' : '✎ Edit APIs' }}
      </button>
    </div>
    <div class="conflict-chips">
      <span *ngFor="let api of data.conflictingApis"
            class="api-chip"
            [class.api-chip-resolved]="!isConflict(api)">
        <span *ngIf="!isConflict(api)" class="chip-check">✓</span>
        {{ api }}
      </span>
    </div>
  </div>

  <!-- Table -->
  <div class="table-wrap">
    <table class="data-grid">
      <thead>
        <tr>
          <th>API</th>
          <th>Well Name</th>
          <th>Frac Start</th>
          <th>Frac End</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data.records" [class.row-conflict]="isConflict(row.api)">
          <td class="api-cell">
            <ng-container *ngIf="editMode && row._wasConflict; else apiReadonly">
              <div class="api-edit-wrap" [class.api-edit-resolved]="!isConflict(row.api)">
                <span *ngIf="isConflict(row.api)" class="conflict-marker">⚠</span>
                <span *ngIf="!isConflict(row.api)" class="resolved-marker">✓</span>
                <input class="api-input"
                       [value]="row.api"
                       (input)="onApiEdit(row, $event)"
                       [class.input-conflict]="isConflict(row.api)"
                       [class.input-resolved]="!isConflict(row.api)" />
              </div>
            </ng-container>
            <ng-template #apiReadonly>
              <span *ngIf="isConflict(row.api)" class="conflict-marker">⚠</span>
              {{ row.api }}
            </ng-template>
          </td>
          <td>{{ row.wellName }}</td>
          <td>{{ formatDate(row.fracStartDate) }}</td>
          <td>{{ formatDate(row.fracEndDate) }}</td>
          <td><span [ngClass]="'state-badge ' + getStateClass(row.editState)">{{ row.editState }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <div class="footer-hint" *ngIf="hasConflicts">Resolve all API conflicts to enable Accept Changes.</div>
    <div class="footer-hint footer-hint-ok" *ngIf="!hasConflicts && editMode">All conflicts resolved — you can now accept.</div>
    <div class="footer-actions">
      <button class="btn btn-discard" (click)="discard()">Discard</button>
      <button class="btn btn-accept" (click)="acceptChanges()" [disabled]="hasConflicts">Accept Changes</button>
    </div>
  </div>

</div>
